import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'absolute',
})
export class AbsolutePipe implements PipeTransform {
  transform(number: any) {
    if (number && number < 0) {
      return -number;
    } else {
      return number;
    }
  }
}
